import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import { useAuth } from "../context/AuthContext";
import Button from "./Button";
import Form from "./Form";
import TextInput from "./TextInput";
const LoginForm = () => {
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState();
  const [loading, setloading] = useState(false);
  const history = useHistory();
  const { login } = useAuth();

  async function handleSubmit(e) {
    e.preventDefault();
    //do validation
    try {
      setError("");
      setloading(true);

      if (
        email === process.env.REACT_APP_ADMIN_EMAIL &&
        password === process.env.REACT_APP_ADMIN_PASSWORD
      ) {
        await login(email, password);
        history.push("/");
      } else {
        setloading(false);
        setError("User Not Found.");
      }
    } catch (err) {
      setloading(false);
      setError("User Not Found.");
    }
  }

  return (
    <Form onSubmit={(e) => handleSubmit(e)} style={{ height: "330px" }}>
      <TextInput
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        type="text"
        placeholder="Enter email"
        icon="alternate_email"
      />
      <br />
      <TextInput
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        type="password"
        placeholder="Enter password"
        icon="lock"
      />
      <br />
      {error && <p className="error">{error}</p>}
      <br />
      <BeatLoader loading={loading} />
      <Button disabled={loading} type="submit">
        <span>Submit Now</span>
      </Button>
    </Form>
  );
};

export default LoginForm;
